var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.56 0.255098C10.8036 0.331708 11.0164 0.484035 11.1675 0.689925C11.3186 0.895814 11.4 1.14453 11.4 1.3999V7.3999H16.2C16.4195 7.3998 16.6348 7.45991 16.8226 7.57369C17.0103 7.68746 17.1632 7.85055 17.2646 8.04519C17.3661 8.23983 17.4123 8.45858 17.398 8.67762C17.3838 8.89666 17.3098 9.1076 17.184 9.2875L8.78402 21.2875C8.63783 21.4969 8.42862 21.6543 8.18683 21.7366C7.94504 21.8189 7.68329 21.822 7.43966 21.7453C7.19602 21.6686 6.98322 21.5161 6.83221 21.3101C6.6812 21.1041 6.59986 20.8553 6.60002 20.5999V14.5999H1.80002C1.58052 14.6 1.3652 14.5399 1.17748 14.4261C0.98977 14.3123 0.836859 14.1492 0.735393 13.9546C0.633926 13.76 0.587791 13.5412 0.602007 13.3222C0.616223 13.1031 0.690247 12.8922 0.816021 12.7123L9.21602 0.712298C9.36243 0.503242 9.57169 0.346313 9.81338 0.264309C10.0551 0.182306 10.3166 0.179499 10.56 0.256298V0.255098Z",
    fill: "#E22440"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.97c119225a28a5c9ca8253e3ab4bdeb3.svg";
export { ForwardRef as ReactComponent };